import React from "react";

const PaymentResult = () => {
    const location = window.location;

    const searchParams = new URLSearchParams(location.search);

    const getValue = (key: string) => {
        const value = searchParams.get(key);
        return value == null ? "" : value;
    }

    const paymentMethod = getValue("digiapiPaymentMethod");
    //var externalReference = getValue("digiapiExternalRef");
    const payAtTransactionId = getValue("payatTranId");
    const payAtReference = getValue("payatReferenceNum");
    const apiResponseMessage = getValue("digiapiResponseMsg");

    const Line = ({ label, value }: { label: string, value: string }) => {
        return (
            <>
                <dt>{label}</dt>
                <dd>{value}</dd>
            </>
        );
    }

    return (
        <dl>
            <Line label="Transaction Id" value={payAtTransactionId} />
            <Line label="Paid With" value={paymentMethod} />
            <Line label="Pay@ Reference" value={payAtReference} />
            <Line label="Message" value={apiResponseMessage} />
        </dl>
    )
}

export default PaymentResult;
